import React from 'react';

const authContext = React.createContext({ status: false, login: () => {} , logout: () => {}, setUserAuthData: () => {} });

export default authContext;
